module.exports = __webpack_public_path__ + "static/media/prf1.2f843ca9.png";